import { Tooltip } from '@fluentui/react-components';

export interface EllipsisWithTooltipProps {
  /** The text content to display */
  content?: string | null;
}

const ellipsisStyle: React.CSSProperties = {
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  width: '100%',
};

/**
 * A component that displays text with ellipsis overflow and a tooltip showing the full content.
 * Useful for table cells where content may be truncated.
 */
const EllipsisWithTooltip = ({ content }: EllipsisWithTooltipProps) => {
  if (!content) {
    return null;
  }

  return (
    <Tooltip content={content} relationship="label">
      <div style={ellipsisStyle}>{content}</div>
    </Tooltip>
  );
};

export default EllipsisWithTooltip;
